import React from 'react';
import Modal, { ModalPrimaryButton, ModalSecondaryButton } from './Modal';

const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  isDanger = false,
  isLoading = false,
  zIndex = 9999
}) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    title={title}
    icon={isDanger ? "fa-exclamation-triangle" : "fa-circle-info"}
    tone={isDanger ? "danger" : "neutral"}
    size="md"
    zIndex={zIndex}
    // A confirmation must not vanish while its action is running.
    closeOnBackdrop={!isLoading}
    closeOnEscape={!isLoading}
    footer={
      <>
        <ModalSecondaryButton onClick={onClose} disabled={isLoading}>
          {cancelText}
        </ModalSecondaryButton>
        <ModalPrimaryButton
          onClick={onConfirm}
          loading={isLoading}
          loadingText="Processing..."
          tone={isDanger ? "danger" : "default"}
        >
          {confirmText}
        </ModalPrimaryButton>
      </>
    }
  >
    <div className="text-sm text-slate-cloud leading-relaxed">{message}</div>
  </Modal>
);

export default ConfirmationModal;
